import WalletConnectProvider from "@walletconnect/web3-provider";
import WalletLink from "walletlink";

export default {
  // Modals
  openMemeModal: false,
  selectedMeme: null,

  // Theme
  theme: "light",

  // Sidenav
  activeLink: "Featured",

  // Topnav
  searchMessage: null,

  // Web3
  web3: null,
  provider: null,
  account: null,

  //WalletConnect
  providerOptions: {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        infuraId: process.env.VUE_APP_INFURA_ID,
        network: process.env.VUE_APP_CONTRACT_NETWORK,
      },
    },
    walletlink: {
      package: WalletLink,
      options: {
        appName: "The Pixlverse",
        infuraId: process.env.VUE_APP_INFURA_ID,
        chainId: process.env.VUE_APP_CONTRACT_NETWORK === "rinkeby" ? 4 : 1,
      },
    },
  },

  // Memes
  memePreviews: null,

  // User NFTs
  nfts: null,
};
